import en from './en.json'
import es from './es.json'

const LOCALES = {
  en,
  'en-US': en,
  es,
  'en-MX': es
}

export const SUPPORTED_LOCALES = Object.keys(LOCALES)

export default LOCALES
